import { IconButton, Tooltip } from '@mui/material';
import { Create as CreateIcon } from '@mui/icons-material';

export const EditIconButton = ({
  onClick,
  tooltipText,
}: {
  onClick: () => void;
  tooltipText: string;
}) => (
  <Tooltip title={<span style={{ fontSize: '16px' }}>{tooltipText}</span>}>
    <IconButton
      aria-label="edit"
      onClick={onClick}
    >
      <CreateIcon
        sx={{
          fontSize: '16px',
          color: '#6b7280',
        }}
      />
    </IconButton>
  </Tooltip>
);
